import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3.333",
      d: "M25 15 15 25m0-10 10 10m11.666-5c0 9.205-7.462 16.667-16.666 16.667S3.333 29.205 3.333 20 10.795 3.333 20 3.333c9.204 0 16.666 7.462 16.666 16.667"
    }, null, -1)
  ])))
}
export default { render: render }